import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material';

import { Injectable } from '@angular/core';

@Injectable()
export class SnackbarService {

  private snackBarConfig: MatSnackBarConfig;

  constructor(
    private snackBar: MatSnackBar
  ) {
      this.snackBarConfig = new MatSnackBarConfig();
      this.snackBarConfig.duration = 5000;
      this.snackBarConfig.verticalPosition = 'top';
  }

  public open(message: string): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, 'Dismiss', this.snackBarConfig);
  }

  public openInfo(message: string): MatSnackBarRef<SimpleSnackBar> {
    this.snackBarConfig.panelClass = ['app-snackbar-info'];

    return this.open(message);
  }
}
